import {
  UPDATE_SPECIALIST,
  UPDATE_SPECIALIST_FAILURE,
  UPDATE_SPECIALIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const updateSpecialistReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SPECIALIST:
      return { ...state, loading: true };
    case UPDATE_SPECIALIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case UPDATE_SPECIALIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default updateSpecialistReducer;
